module.exports = __webpack_public_path__ + "img/list.4b1ff39d.svg";